<template>
  <div class="chat-container">
    <div class="chat-wrapper">
      <!-- Sidebar Contacts -->
      <div class="chat-sidebar">
        <div class="sidebar-header">
          <div class="header-title">
            <span class="header-icon">💬</span>
            <span>پیام‌های مشتریان</span>
          </div>
          <div class="header-badge">{{ contacts.length }}</div>
        </div>

        <div class="contacts-list">
          <div
              v-for="contact in contacts"
              :key="contact.id"
              @click="contact_id = contact.id"
              :class="['contact-item', { active: contact.id == contact_id }]"
          >
            <div class="contact-avatar">
              <img :src="contact.image || getAvatar(contact.name)" />
              <span class="online-status" v-if="contact.online"></span>
            </div>

            <div class="contact-info">
              <div class="contact-name">{{ contact.name }}</div>
              <div class="contact-email">{{ contact.market.title.title }}</div>
              <div class="contact-phone">📞 {{ contact.phone }}</div>
            </div>

            <div class="contact-badge" v-if="getUnreadCount(contact.id) > 0">
              {{ getUnreadCount(contact.id) }}
            </div>
          </div>

          <div v-if="contacts.length === 0" class="empty-state">
            <span class="empty-icon">👥</span>
            <p>هیچ مشتری‌ای وجود ندارد</p>
          </div>
        </div>
      </div>

      <!-- Chat Main Area -->
      <div class="chat-main">
        <template v-if="contact_id > 0">
          <!-- Chat Header -->
          <div class="chat-header">
            <div class="chat-header-info">
              <img
                  :src="getActiveContact().image || getAvatar(getActiveContact().name)"
                  class="header-avatar"
              />
              <div class="header-details">
                <div class="header-name">{{ getActiveContact().name }}</div>
                <div class="header-status">
                  <span class="status-dot"></span>
                  آنلاین
                </div>
              </div>
            </div>
            <div class="chat-header-actions">
              <button class="action-btn" title="تازه سازی">🔄</button>
              <button class="action-btn" title="بیشتر">•••</button>
            </div>
          </div>

          <!-- Messages Area -->
          <div class="messages-area" id="message_support_root">
            <div
                v-for="(msg, index) in message_list"
                :key="index"
                :class="['message-item', msg.to_id == null ? 'sent' : 'received']"
            >
              <div class="message-bubble">
                <div class="message-sender">
                  <span class="sender-icon">{{ msg.to_id == null ? '👤' : '👔' }}</span>
                  {{ msg.to_id == null ? 'مشتری' : 'شما' }}
                </div>
                <div class="message-text">{{ msg.message }}</div>
                <div class="message-time">🕐 {{ get_date_time(msg.created_at) }}</div>
              </div>
            </div>

            <div v-if="message_list.length === 0" class="empty-messages">
              <span class="empty-msg-icon">💭</span>
              <p>پیامی وجود ندارد</p>
              <span>اولین پیام را ارسال کنید</span>
            </div>
          </div>

          <!-- Message Input -->
          <div class="message-input-area">
            <div class="input-wrapper">
              <button class="attach-btn">📎</button>
              <input
                  type="text"
                  class="message-input"
                  placeholder="پیام خود را بنویسید..."
                  v-model="message"
                  @keyup.enter="send_message()"
              />
              <button
                  class="send-btn"
                  @click="send_message()"
                  :disabled="!message.trim()"
              >
                ✉ ارسال
              </button>
            </div>
          </div>
        </template>

        <!-- No Contact Selected -->
        <template v-else>
          <div class="no-contact-selected">
            <span class="no-contact-icon">💬</span>
            <h3>یک مشتری را انتخاب کنید</h3>
            <p>برای شروع مکالمه، از لیست سمت راست یک مشتری را انتخاب کنید</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { bus } from '../../main';

export default {
  name: 'ChatSystem',
  components: {},
  data() {
    return {
      message: '',
      unread_list: [],
      contacts: [],
      message_list: [],
      contact_id: 0,
    }
  },
  mounted() {
    this.get_contacts();
  },
  watch: {
    'contact_id': function() {
      this.get_messages();
    }
  },
  methods: {
    getAvatar(name) {
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=667eea&color=fff&size=45`;
    },
    getUnreadCount(contactId) {
      const found = this.unread_list.filter(x => x.from_id == contactId);
      return found.length > 0 ? found[0].count : 0;
    },
    getActiveContact() {
      return this.contacts.find(c => c.id == this.contact_id) || {};
    },
    get_contacts() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/super-admin/site/get_contacts', formData, {})
          .then(function(response) {
            self.contacts = response.data.data;
            self.unread_list = response.data.unread;
          })
          .catch(function(error) {
            console.log(error);
          });
    },
    get_messages() {
      var self = this;
      var formData = new FormData();
      formData.append('contact_id', this.contact_id);
      axios.post('/api/super-admin/site/get_admin_messages', formData, {})
          .then(function(response) {
            self.message_list = response.data;
            setTimeout(function() {
              var objDiv = document.getElementById("message_support_root");
              if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
            }, 300);
            bus.$emit('update_unread_message', {});
          })
          .catch(function(error) {
            console.log(error);
          });
    },
    send_message() {
      var self = this;
      if (this.message.trim() == '') return false;

      var formData = new FormData();
      formData.append('contact_id', this.contact_id);
      formData.append('message', this.message);

      axios.post('/api/super-admin/site/send_admin_messages', formData, {})
          .then(function(response) {
            if (response.data.error == 0) {
              self.message_list.push({
                message: self.message,
                to_id: 0,
                from_id: null,
                created_at: new Date(),
                updated_at: new Date(),
              });
              self.message = '';
              setTimeout(function() {
                var objDiv = document.getElementById("message_support_root");
                if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
              }, 300);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
    },
    get_date_time(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleString('fa-IR', {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  }
}
</script>

<style scoped>
/* ===== RESET & BASE ===== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.chat-container {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-wrapper {
  display: flex;
  width: 100%;
  max-width: 1400px;
  height: 85vh;
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

/* ===== SIDEBAR ===== */
.chat-sidebar {
  width: 380px;
  min-width: 320px;
  background: #f8f9fc;
  border-right: 1px solid #e9edf2;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  padding: 20px 24px;
  background: #fff;
  border-bottom: 1px solid #e9edf2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #2d3748;
}

.header-icon {
  font-size: 22px;
}

.header-badge {
  background: #667eea;
  color: #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}

/* Contacts List */
.contacts-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.contacts-list::-webkit-scrollbar {
  width: 4px;
}
.contacts-list::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 4px;
}

.contact-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  position: relative;
}

.contact-item:hover {
  background: #edf2f7;
}

.contact-item.active {
  background: #eef2ff;
  border-left-color: #667eea;
}

.contact-avatar {
  position: relative;
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.contact-avatar img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e2e8f0;
}

.online-status {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  background: #48bb78;
  border-radius: 50%;
  border: 2px solid #fff;
}

.contact-info {
  flex: 1;
  margin: 0 12px;
  min-width: 0;
}

.contact-name {
  font-size: 15px;
  font-weight: 600;
  color: #2d3748;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-email {
  font-size: 12px;
  color: #718096;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-phone {
  font-size: 11px;
  color: #a0aec0;
  margin-top: 2px;
}

.contact-badge {
  background: #667eea;
  color: #fff;
  border-radius: 50%;
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  padding: 0 6px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #a0aec0;
}

.empty-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}

/* ===== CHAT MAIN ===== */
.chat-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

/* Chat Header */
.chat-header {
  padding: 16px 24px;
  background: #fff;
  border-bottom: 1px solid #e9edf2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chat-header-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e2e8f0;
}

.header-details {
  display: flex;
  flex-direction: column;
}

.header-name {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
}

.header-status {
  font-size: 13px;
  color: #48bb78;
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot {
  width: 8px;
  height: 8px;
  background: #48bb78;
  border-radius: 50%;
  display: inline-block;
}

.chat-header-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #718096;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 0.2s;
}

.action-btn:hover {
  background: #edf2f7;
}

/* Messages Area */
.messages-area {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
  background: #f7fafc;
}

.messages-area::-webkit-scrollbar {
  width: 4px;
}
.messages-area::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 4px;
}

.message-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.message-item.sent {
  align-items: flex-end;
}

.message-item.received {
  align-items: flex-start;
}

.message-bubble {
  max-width: 65%;
  padding: 12px 16px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  word-wrap: break-word;
}

.message-item.sent .message-bubble {
  background: #667eea;
  color: #fff;
  border-bottom-right-radius: 4px;
}

.message-item.received .message-bubble {
  background: #fff;
  color: #2d3748;
  border-bottom-left-radius: 4px;
  border: 1px solid #e9edf2;
}

.message-sender {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.message-item.sent .message-sender {
  color: #c3d0ff;
}

.message-item.received .message-sender {
  color: #718096;
}

.sender-icon {
  font-size: 14px;
}

.message-text {
  font-size: 15px;
  line-height: 1.5;
}

.message-time {
  font-size: 11px;
  opacity: 0.7;
  margin-top: 6px;
  text-align: right;
}

.message-item.sent .message-time {
  color: #c3d0ff;
}

.message-item.received .message-time {
  color: #a0aec0;
}

.empty-messages {
  text-align: center;
  padding: 60px 20px;
  color: #a0aec0;
}

.empty-msg-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}

.empty-messages p {
  font-size: 18px;
  font-weight: 600;
  color: #718096;
}

.empty-messages span {
  font-size: 14px;
}

/* Message Input */
.message-input-area {
  padding: 16px 24px;
  background: #fff;
  border-top: 1px solid #e9edf2;
}

.input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f7fafc;
  border-radius: 12px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  transition: border-color 0.2s;
}

.input-wrapper:focus-within {
  border-color: #667eea;
}

.attach-btn {
  background: none;
  border: none;
  font-size: 20px;
  padding: 8px 12px;
  color: #a0aec0;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s;
}

.attach-btn:hover {
  background: #edf2f7;
}

.message-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  padding: 10px 0;
  font-size: 15px;
  color: #2d3748;
}

.message-input::placeholder {
  color: #a0aec0;
}

.send-btn {
  background: #667eea;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.send-btn:hover:not(:disabled) {
  background: #5a6fd6;
  transform: scale(1.02);
}

.send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* No Contact Selected */
.no-contact-selected {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #a0aec0;
  padding: 40px;
}

.no-contact-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.no-contact-selected h3 {
  font-size: 22px;
  color: #2d3748;
  margin-bottom: 8px;
}

.no-contact-selected p {
  font-size: 16px;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 992px) {
  .chat-sidebar {
    width: 300px;
    min-width: 260px;
  }
}

@media (max-width: 768px) {
  .chat-wrapper {
    flex-direction: column;
    height: 95vh;
    border-radius: 16px;
  }

  .chat-sidebar {
    width: 100%;
    min-width: unset;
    max-height: 35vh;
    border-right: none;
    border-bottom: 1px solid #e9edf2;
  }

  .chat-main {
    flex: 1;
  }

  .message-bubble {
    max-width: 85%;
  }

  .sidebar-header {
    padding: 14px 16px;
  }

  .contact-item {
    padding: 10px 14px;
  }
}

@media (max-width: 480px) {
  .chat-container {
    padding: 10px;
  }

  .chat-header {
    padding: 12px 14px;
  }

  .messages-area {
    padding: 12px 14px;
  }

  .message-input-area {
    padding: 12px 14px;
  }

  .send-btn {
    padding: 8px 14px;
    font-size: 13px;
  }

  .header-title {
    font-size: 15px;
  }

  .contact-avatar {
    width: 40px;
    height: 40px;
  }

  .contact-avatar img {
    width: 40px;
    height: 40px;
  }
}
</style>